;
define("product_views_option_textarea.tpl", function(){});

